import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReadUI from "../contents/ReadUI";
import DetailHeader from "../components/DetailHeader";
import getListen from "../api/get/getListen";
import { useExtractColors } from "react-extract-colors";
import isDarkColor from "../utils/isDarkColor";
import Loading from "../components/Loading";

import { analytics, logEvent, realtimeDb, auth } from "../config";
import { ref, set, remove, onValue } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";

const Read = () => {
    const { bookId } = useParams();
    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);
    const audioRef = useRef(null);
    const [onlineCount, setOnlineCount] = useState(0);
    const userIdRef = useRef(null);

    useEffect(() => {
        const fetchBook = async () => {
            if (!bookId) return;
            setLoading(true);
            try {
                const bookData = await getListen(bookId);
                if (bookData) {
                    setBook(bookData);

                    if (analytics) {
                        logEvent(analytics, "start_reading", {
                            book_id: bookId,
                            title: bookData.title,
                            timestamp: new Date().toISOString(),
                        });
                    }

                    onAuthStateChanged(auth, (user) => {
                        const uid = user ? user.uid : `anon-${Date.now()}`;
                        userIdRef.current = uid;

                        const onlineRef = ref(realtimeDb, `online_reads/${bookId}/${uid}`);
                        set(onlineRef, true);

                        const bookCountRef = ref(realtimeDb, `online_reads/${bookId}`);
                        onValue(bookCountRef, (snapshot) => {
                            const data = snapshot.val();
                            setOnlineCount(data ? Object.keys(data).length : 0);
                        });
                    });
                } else {
                    console.log("Кітап табылмады!");
                }
            } catch (error) {
                console.error("Қате:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBook();

        return () => {
            if (bookId && userIdRef.current) {
                const onlineRef = ref(realtimeDb, `online_reads/${bookId}/${userIdRef.current}`);
                remove(onlineRef);
            }
        };
    }, [bookId]);

    const { dominantColor, lighterColor } = useExtractColors(book?.imageUrl || "");
    const textColor = dominantColor
        ? isDarkColor(dominantColor) ? "#fff" : "#000"
        : "#000";

    if (loading) return <Loading />;
    if (!book) return <p className="text-center text-red-500 mt-10">Кітап табылмады!</p>;

    return (
        <div
            className="flex flex-col min-h-screen transition-colors duration-500"
            style={{ backgroundColor: lighterColor }}
        >
            <div className="flex-grow space-y-6 px-4 py-6 pt-0">
                <ReadUI book={book} audioRef={audioRef} textColor={textColor} bookId={bookId} />
            </div>
        </div>
    );
};

export default Read;